import { RouteObject } from 'react-router-dom';

import Cost from 'pages/NewCost';
import Print from 'pages/print';
import CostLine from 'pages/costs/costLine/CostLine';
import { CostDetails } from 'pages/Invoices/costDetails';

import PrivateRoute from '../hoc/PrivateRoute';
import NewInvoice from '../pages/NewInvoice';
import CreateInvoice from '../pages/Invoices';
import Drafts from '../pages/Invoices/drafts';
import Expenses from '../pages/Invoices/expenses';
import Incomes from '../pages/Invoices/incomes';
import { InvoiceDetails } from '../pages/Invoices/invoiceDetails';
import InvoiceLine from '../pages/Invoices/invoiceLine/InvoiceLine';

export const invoiceRoutes: RouteObject[] = [
  {
    path: '/invoices/create',
    element: (
      <PrivateRoute>
        <CreateInvoice />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/new/:draftId?',
    element: (
      <PrivateRoute>
        <NewInvoice />
      </PrivateRoute>
    ),
  },
  {
    path: '/cost/new/:draftId?',
    element: (
      <PrivateRoute>
        <Cost />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/line/:invoiceDraftId?',
    element: (
      <PrivateRoute>
        <InvoiceLine />
      </PrivateRoute>
    ),
  },
  {
    path: '/cost/line/:costDraftId?',
    element: (
      <PrivateRoute>
        <CostLine />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/incomes',
    element: (
      <PrivateRoute>
        <Incomes />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/expenses',
    element: (
      <PrivateRoute>
        <Expenses />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/drafts',
    element: (
      <PrivateRoute>
        <Drafts />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/:id/detail/:partnerId?',
    element: (
      <PrivateRoute>
        <InvoiceDetails />
      </PrivateRoute>
    ),
  },
  {
    path: '/cost/:id/detail/:partnerId?',
    element: (
      <PrivateRoute>
        <CostDetails />
      </PrivateRoute>
    ),
  },
  {
    path: '/invoices/print',
    element: (
      <PrivateRoute>
        <Print />
      </PrivateRoute>
    ),
  },
];
